module.exports = __webpack_public_path__ + "static/img/fopter-image.f549080.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fopter-image.png
// module id = qAkx
// module chunks = 12